import { createRoutine } from 'redux-saga-routines';

export const pharmacySearchRoutine = createRoutine('PHARMACY/SEARCH');
export const pharmacyGroupByRoutine = createRoutine('PHARMACY/GROUPBY');
export const pharmacyLookUpRoutine = createRoutine('PHARMACY/LOOKUP');
